import { ref } from "vue";
import { auth, db } from "./index";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import store from "@/store";

const currentUser = ref(null);

// Store the unsubscribe function for the user document listener
let unsubscribeUserDoc = null;

// Immediately subscribe to auth state changes (no onMounted here)
onAuthStateChanged(auth, async (user) => {
  currentUser.value = user;

  // Unsubscribe from previous user document listener if any
  if (unsubscribeUserDoc) {
    unsubscribeUserDoc();
    unsubscribeUserDoc = null;
  }

  // If user is logged in, subscribe to their document for real-time role updates
  if (user) {
    store.commit("setUser", user);
    
    // Use onSnapshot for real-time updates when role changes in the database
    unsubscribeUserDoc = onSnapshot(
      doc(db, "users", user.uid),
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const userData = docSnapshot.data();
          const role = userData.privileges || "visitor";
          store.commit("setUserRole", role);
        } else {
          // User document doesn't exist, set default role
          store.commit("setUserRole", "visitor");
        }
      },
      (error) => {
        // Set default role on error
        store.commit("setUserRole", "visitor");
      }
    );
  } else {
    // User is logged out, clear user and role in store
    store.commit("setUser", null);
    store.commit("setUserRole", null);
  }
});

async function logout() {
  try {
    await signOut(auth);
  } catch (error) {
    throw error;
  }
}

export function useAuth() {
  return { currentUser, logout };
}
